
(function(template){
    define('vue!app/views/vue/basicComponents/spdropdown',['Vue', 'vuex'],function(Vue, vuex){
        return {
            template:template,
            props: ['options','selected'],
            methods: _.extend(vuex.mapMutations(['setActiveService']),{
                
                handleRadioClick: function(val){
                    this.$emit('update:selected',val)
                    this.$emit('setActiveServ',val)
                },
                handleSelect: function(val){
                    this.$emit('update:selected',val.target.value)
                    this.$emit('setActiveServ',val.target.value)
                }
            })
        }
    })
})('<div class="radioButtonContainer"> <div class="todDropCont"> <h5>{{localStrings.stepper.body.schedule.timePicker.pickTimeLabel}}</h5> <div> <select @change="handleSelect($event)"> <option class="filter-item" v-for="(filter,index) in options" :key="index" :tabindex="selected==filter.val ? 0 : -1" :aria-checked="selected==filter.val" :id="filter.val" :checked="selected==filter.val" :value="filter.val">{{filter.name}}</option> </select> <i class="fas fa-chevron-down"></i> </div> </div> </div>');
